export const productsData = [
  {
    "id": 1,
    "name": "Abamectin 1.8% EC",
    "category": "Insecticide",
    "slug": "abamectin-1-8-ec",
    "packSize": "400 ml",
    "price": 575,
    "image": "/images/abamectin-1-8-ec.jpeg",
    "description": "Imported insecticide for effective pest control.",
    "fullDescription": " Abamectin is an insecticide and acaricide belonging to the avermectin family (a subset of macrocyclic lactones) and is classified under IRAC Group 6 (Glutamate-gated chloride channel activators). Derived from the soil bacterium Streptomyces avermitilis, it is a natural fermentation product used to control mites and insects, acting primarily through ingestion and contact to paralyze pests.",
    "groupKey": "abamectin-1-8-ec",
    "groupTitle": "Abamectin 1.8% EC",
    "variantLabel": "400 ml",
    "labelImage": "/images/ProductLable/Abamectin 400ml Label_page-0001.jpg"
  },
  {
    "id": 2,
    "name": "Acephate 75% SP111",
    "category": "Insecticide",
    "slug": "acephate-75-sp",
    "packSize": "250 gm",
    "price": 650,
    "image": "/images/acephate.jpeg",
    "description": "Imported systemic insecticide formulation.",
    "fullDescription": "Acephate 75% SP is an imported systemic insecticide that provides effective control against a wide range of sucking and chewing insects.",
    "groupKey": "acephate-75-sp",
    "groupTitle": "Acephate 75% SP",
    "variantLabel": "250 gm"
  },
  {
    "id": 3,
    "name": "Acephate 75% SP (300gm)",
    "category": "Insecticide",
    "slug": "acephate-75-sp-300",
    "packSize": "300 gm",
    "price": 735,
    "image": "/images/acephate.jpeg",
    "description": "Larger pack size of imported systemic insecticide.",
    "fullDescription": "Acephate 75% SP in 300gm pack offers economical option for larger field applications with systemic action against various pests.",
    "groupKey": "acephate-75-sp",
    "groupTitle": "Acephate 75% SP",
    "variantLabel": "300 gm"
  },
  {
    "id": 4,
    "name": "Acetamiprid 20% SP",
    "category": "Insecticide",
    "slug": "acetamiprid-20-sp",
    "packSize": "250 gm",
    "price": 450,
    "image": "/images/Acetaamiprid.jpeg",
    "description": "Neonicotinoid insecticide for sucking insects.",
    "fullDescription": "Acetamiprid 20% SP is an imported neonicotinoid insecticide effective against sucking insects like aphids, whiteflies and leafhoppers.",
    "groupKey": "acetamiprid-20-sp",
    "groupTitle": "Acetamiprid 20% SP",
    "variantLabel": "250 gm",
    "labelImage": "/images/ProductLable/Aceta SP 250gm Digita Printnig Pouch_page-0001.jpg"
  },
  {
    "id": 5,
    "name": "Aluminium Phosphide 56% (Tube)",
    "category": "Insecticide",
    "slug": "aluminium-phosphide-56-tube",
    "packSize": "30gm/16tube/40tin",
    "price": 95,
    "image": "/images/aluminium.jpeg",
    "description": "Fumigant for grain storage protection.",
    "fullDescription": "Aluminium Phosphide 56% in tube form is an imported fumigant for effective grain storage protection and pest control.",
    "groupKey": "aluminium-phosphide-56",
    "groupTitle": "Aluminium Phosphide 56%",
    "variantLabel": "Tube (30gm)"
  },
  {
    "id": 6,
    "name": "Aluminium Phosphide 56% (Gandum Goli)",
    "category": "Insecticide",
    "slug": "aluminium-phosphide-56-gandum-goli",
    "packSize": "1.5 kg",
    "price": 3000,
    "image": "/images/aluminium.jpeg",
    "description": "Grain fumigant in larger pack.",
    "fullDescription": "Aluminium Phosphide 56% Gandum Goli provides effective fumigation for large grain storage facilities.",
    "groupKey": "aluminium-phosphide-56",
    "groupTitle": "Aluminium Phosphide 56%",
    "variantLabel": "Gandum Goli (1.5kg)"
  },
  {
    "id": 7,
    "name": "Bifenthrin 10% EC",
    "category": "Insecticide",
    "slug": "bifenthrin-10-ec-250",
    "packSize": "250 ml",
    "price": 500,
    "image": "/images/Bifenthrin.jpeg",
    "description": "Imported broad-spectrum synthetic pyrethroid.",
    "fullDescription": "Bifenthrin 10% EC imported is a broad-spectrum synthetic pyrethroid for effective control of various crop pests.",
    "groupKey": "bifenthrin-10-ec",
    "groupTitle": "Bifenthrin 10% EC",
    "variantLabel": "250 ml",
    "labelImage": "/images/ProductLable/Bifenthrin 500ml Label (Pet Botal)_page-0001.jpg"
  },
  {
    "id": 8,
    "name": "Bifenthrin 10% EC (500ml)",
    "category": "Insecticide",
    "slug": "bifenthrin-10-ec-500",
    "packSize": "500 ml",
    "price": 900,
    "image": "/images/Bifenthrin.jpeg",
    "description": "Medium pack of imported pyrethroid insecticide.",
    "fullDescription": "Bifenthrin 10% EC in 500ml pack offers better value for medium to large field applications.",
    "groupKey": "bifenthrin-10-ec",
    "groupTitle": "Bifenthrin 10% EC",
    "variantLabel": "500 ml",
    "labelImage": "/images/ProductLable/Bifenthrin 500ml Label (Pet Botal)_page-0001.jpg"
  },
  {
    "id": 9,
    "name": "Bifenthrin 10% EC (1000ml)",
    "category": "Insecticide",
    "slug": "bifenthrin-10-ec-1000",
    "packSize": "1000 ml",
    "price": 1600,
    "image": "/images/Bifenthrin.jpeg",
    "description": "Large pack synthetic pyrethroid concentrate.",
    "fullDescription": "Bifenthrin 10% EC in 1L pack provides economical option for extensive pest management programs.",
    "groupKey": "bifenthrin-10-ec",
    "groupTitle": "Bifenthrin 10% EC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Bifenthrin 500ml Label (Pet Botal)_page-0001.jpg"
  },
  {
    "id": 10,
    "name": "Ceedo 20% SC",
    "category": "Insecticide",
    "slug": "ceedo-20-sc-200",
    "packSize": "200 ml",
    "price": 370,
    "image": "/images/ceedo.jpeg",
    "description": "Suspension concentrate insecticide formulation.",
    "fullDescription": "Ceedo 20% SC is an effective suspension concentrate formulation for pest management.",
    "groupKey": "ceedo-20-sc",
    "groupTitle": "Ceedo 20% SC",
    "variantLabel": "200 ml",
    "labelImage": "/images/ProductLable/Ceedo 200ml 20SC (Clothianidin) Label_page-0001.jpg"
  },
  {
    "id": 11,
    "name": "Ceedo 20% SC (1000ml)",
    "category": "Insecticide",
    "slug": "ceedo-20-sc-1000",
    "packSize": "1000 ml",
    "price": 1300,
    "image": "/images/ceedo20%sc.jpeg",
    "description": "Large pack of suspension concentrate.",
    "fullDescription": "Ceedo 20% SC in 1L pack provides economical option for larger scale applications.",
    "groupKey": "ceedo-20-sc",
    "groupTitle": "Ceedo 20% SC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Ceedo 200ml 20SC (Clothianidin) Label_page-0001.jpg"
  },
  {
    "id": 12,
    "name": "Chlorfenapyr 36% SC",
    "category": "Insecticide",
    "slug": "chlorfenapyr-36-sc",
    "packSize": "200 ml",
    "price": 800,
    "image": "/images/chlorphenpyr.jpeg",
    "description": "Imported pro-insecticide for broad pest control.",
    "fullDescription": "Chlorfenapyr 36% SC imported offers broad-spectrum pest control with unique mode of action.",
    "groupKey": "chlorfenapyr-36-sc",
    "groupTitle": "Chlorfenapyr 36% SC",
    "variantLabel": "200 ml",
    "labelImage": "/images/ProductLable/Chlorfenapyr 200ml Label (HDP)_page-0001.jpg"
  },
  {
    "id": 13,
    "name": "Clada 25%  Imported (Imidacloprid 200gm)",
    "category": "Insecticide",
    "slug": "clada-25-wp-200",
    "packSize": "200 gm",
    "price": 375,
    "image": "/images/clada.jpeg",
    "description": "Imported neonicotinoid wettable powder.",
    "fullDescription": "Clada 25% WP containing Imidacloprid is an imported neonicotinoid for effective sucking pest control.",
    "groupKey": "clada-25-wp",
    "groupTitle": "Clada 25% WP (Imidacloprid)",
    "variantLabel": "200 gm (Imported)"
  },
  {
    "id": 14,
    "name": "Clada 25% WP (Imidacloprid 250gm)",
    "category": "Insecticide",
    "slug": "clada-25-wp-250",
    "packSize": "250 gm",
    "price": 475,
    "image": "/images/clada.jpeg",
    "description": "Medium pack of neonicotinoid wettable powder.",
    "fullDescription": "Clada 25% WP in larger 250gm pack provides economical option for field applications.",
    "groupKey": "clada-25-wp",
    "groupTitle": "Clada 25% WP (Imidacloprid)",
    "variantLabel": "250 gm"
  },
  {
    "id": 15,
    "name": "Cladda 25% WP (Imidacloprid 100gm)",
    "category": "Insecticide",
    "slug": "cladda-25-wp-100",
    "packSize": "100 gm",
    "price": 225,
    "image": "/images/clada.jpeg",
    "description": "Small pack neonicotinoid for trial applications.",
    "fullDescription": "Cladda 25% WP with Imidacloprid in small 100gm pack is ideal for small field trials and applications.",
    "groupKey": "clada-25-wp",
    "groupTitle": "Clada 25% WP (Imidacloprid)",
    "variantLabel": "100 gm"
  },
  {
    "id": 16,
    "name": "Cypermethrin 10% EC",
    "category": "Insecticide",
    "slug": "cypermethrin-10-ec-250",
    "packSize": "250 ml",
    "price": 350,
    "image": "/images/cypermethrin.jpeg",
    "description": "Synthetic pyrethroid for broad pest control.",
    "fullDescription": "Cypermethrin 10% EC is a reliable synthetic pyrethroid for effective control of various crop pests.",
    "groupKey": "cypermethrin-10-ec",
    "groupTitle": "Cypermethrin 10% EC",
    "variantLabel": "250 ml",
    "labelImage": "/images/ProductLable/Cypermethrin 250ml Label Final_page-0001.jpg"
  },
  {
    "id": 17,
    "name": "Cypermethrin 10% EC (1000ml)",
    "category": "Insecticide",
    "slug": "cypermethrin-10-ec-1000",
    "packSize": "1000 ml",
    "price": 985,
    "image": "/images/cypermethrin.jpeg",
    "description": "Large pack pyrethroid concentrate.",
    "fullDescription": "Cypermethrin 10% EC in 1L pack provides economical solution for large-scale pest management.",
    "groupKey": "cypermethrin-10-ec",
    "groupTitle": "Cypermethrin 10% EC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Cypermethrin 250ml Label Final_page-0001.jpg"
  },
  {
    "id": 18,
    "name": "Dimethoate 40% IMP",
    "category": "Insecticide",
    "slug": "dimethoate-40",
    "packSize": "400 ml",
    "price": 700,
    "image": "/images/dimethoate.jpeg",
    "description": "Imported systemic and contact insecticide.",
    "fullDescription": "Dimethoate 40% imported combines systemic and contact action for comprehensive pest control.",
    "groupKey": "dimethoate-40-imp",
    "groupTitle": "Dimethoate 40% IMP",
    "variantLabel": "400 ml",
    "labelImage": "/images/ProductLable/Dimethoate 400ml Label_page-0001.jpg"
  },
  {
    "id": 19,
    "name": "Dumei 50% (Flonicamid 120gm)",
    "category": "Insecticide",
    "slug": "dumei-50-120",
    "packSize": "120 gm",
    "price": 1525,
    "image": "/images/Dumei.jpeg",
    "description": "Premium imported flonicamid formulation.",
    "fullDescription": "Dumei 50% containing Flonicamid is a premium imported product for sucking insect control.",
    "groupKey": "dumei-50-wg",
    "groupTitle": "Dumei 50% WG (Flonicamid)",
    "variantLabel": "120 gm",
    "labelImage": "/images/ProductLable/Dumei 60gm Label 2026_page-0001.jpg"
  },
  {
    "id": 20,
    "name": "Dumei 50% WG (Flonicamid 60gm)",
    "category": "Insecticide",
    "slug": "dumei-50-wg-60",
    "packSize": "60 gm",
    "price": 825,
    "image": "/images/Dumei.jpeg",
    "description": "Water-dispersible granule formulation.",
    "fullDescription": "Dumei 50% WG with Flonicamid offers convenient water-dispersible granule format for pest management.",
    "groupKey": "dumei-50-wg",
    "groupTitle": "Dumei 50% WG (Flonicamid)",
    "variantLabel": "60 gm",
    "labelImage": "/images/ProductLable/Dumei 60gm Label 2026_page-0001.jpg"
  },
  {
    "id": 21,
    "name": "Dursban 40% EC (Chlorpyrifos 250ml)",
    "category": "Insecticide",
    "slug": "dursban-40-ec-250",
    "packSize": "250 ml",
    "price": 440,
    "image": "/images/dursban-40-ec-imported.jpeg",
    "description": "Organophosphate insecticide concentrate.",
    "fullDescription": "Dursban 40% EC containing Chlorpyrifos is an effective organophosphate for broad pest control.",
    "groupKey": "dursban-40-ec",
    "groupTitle": "Dursban 40% EC (Chlorpyrifos)",
    "variantLabel": "250 ml",
    "labelImage": "/images/ProductLable/Dursban+ 48EC 100ml Label_page-0001.jpg"
  },
  {
    "id": 22,
    "name": "Dursban 40% EC (Chlorpyrifos 1000ml)",
    "category": "Insecticide",
    "slug": "dursban-40-ec-1000",
    "packSize": "1000 ml",
    "price": 1500,
    "image": "/images/dursban-40-ec-imported.jpeg",
    "description": "Large pack of organophosphate concentrate.",
    "fullDescription": "Dursban 40% EC in 1L pack provides economical option for extensive pest management.",
    "groupKey": "dursban-40-ec",
    "groupTitle": "Dursban 40% EC (Chlorpyrifos)",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Darsban (Chlorpyrifos) 1Ltr Label.cdr 1_page-0001.jpg"
  },
  {
    "id": 23,
    "name": "Dursban 40% EC Imported (1000ml)",
    "category": "Insecticide",
    "slug": "dursban-40-ec-imported",
    "packSize": "1000 ml",
    "price": 1595,
    "image": "/images/dursban-40-ec-imported.jpeg",
    "description": "Premium imported organophosphate.",
    "fullDescription": "Dursban 40% EC imported (1L) offers premium quality organophosphate for reliable pest control.",
    "groupKey": "dursban-40-ec",
    "groupTitle": "Dursban 40% EC (Chlorpyrifos)",
    "variantLabel": "1000 ml (Imported)",
    "labelImage": "/images/ProductLable/Darsban (Chlorpyrifos) 1Ltr Label.cdr 1_page-0001.jpg"
  },
  {
    "id": 24,
    "name": "Emamectin 1.9% EC",
    "category": "Insecticide",
    "slug": "emamectin-1-9-ec-200",
    "packSize": "200 ml",
    "price": 320,
    "image": "/images/emamectinbenzoate.jpeg",
    "description": "Avermectin-based insecticide concentrate.",
    "fullDescription": "Emamectin 1.9% EC is an avermectin-based insecticide effective against lepidopteran and mite pests.",
    "groupKey": "emamectin-benzoate-series",
    "groupTitle": "Emamectin Benzoate Series",
    "variantLabel": "1.9% EC (1000ml)",
    "labelImage": "/images/ProductLable/Emamectin 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 25,
    "name": "Emamectin 1.9% EC (1000ml)",
    "category": "Insecticide",
    "slug": "emamectin-1-9-ec-1000",
    "packSize": "1000 ml",
    "price": 1350,
    "image": "/images/emamectinbenzoate.jpeg",
    "description": "Large pack avermectin concentrate.",
    "fullDescription": "Emamectin 1.9% EC in 1L pack is economical for large field applications.",
    "groupKey": "emamectin-benzoate-series",
    "groupTitle": "Emamectin Benzoate Series",
    "variantLabel": "1.9% EC (1000ml)",
    "labelImage": "/images/ProductLable/Emamectin 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 26,
    "name": "Emamectin 1.9% EC Imported (1000ml)",
    "category": "Insecticide",
    "slug": "emamectin-1-9-ec-imported-1000",
    "packSize": "1000 ml",
    "price": 1450,
    "image": "/images/emamectinbenzoate.jpeg",
    "description": "Premium imported avermectin concentrate.",
    "fullDescription": "Emamectin 1.9% EC imported (1L) provides premium quality for critical pest management.",
    "groupKey": "emamectin-benzoate-series",
    "groupTitle": "Emamectin Benzoate Series",
    "variantLabel": "1.9% EC (1000ml Imported)",
    "labelImage": "/images/ProductLable/Emamectin 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 27,
    "name": "Emamectin 1.9% EC Imported (400ml)",
    "category": "Insecticide",
    "slug": "emamectin-1-9-ec-imported-400",
    "packSize": "400 ml",
    "price": 640,
    "image": "/images/emamectinbenzoate.jpeg",
    "description": "Medium pack of imported avermectin.",
    "fullDescription": "Emamectin 1.9% EC imported in 400ml pack offers convenient size for field applications.",
    "groupKey": "emamectin-benzoate-series",
    "groupTitle": "Emamectin Benzoate Series",
    "variantLabel": "1.9% EC (400ml)",
    "labelImage": "/images/ProductLable/Emamectin 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 28,
    "name": "Emamectin 5% WDG",
    "category": "Insecticide",
    "slug": "emamectin-5-wdg-150",
    "packSize": "150 gm",
    "price": 550,
    "image": "/images/emamectinbenzoate.jpeg",
    "description": "Water-dispersible granule formulation.",
    "fullDescription": "Emamectin 5% WDG imported in water-dispersible granule format for convenient application.",
    "groupKey": "emamectin-benzoate-series",
    "groupTitle": "Emamectin Benzoate Series",
    "variantLabel": "5% WDG (150gm)",
    "labelImage": "/images/ProductLable/Emamection Benzoaite 5WDG 150gm Label_page-0001.jpg"
  },
  {
    "id": 29,
    "name": "Emamectin 5% WDG (75gm)",
    "category": "Insecticide",
    "slug": "emamectin-5-wdg-75",
    "packSize": "75 gm",
    "price": 330,
    "image": "/images/emamectinbenzoate.jpeg",
    "description": "Small pack water-dispersible granule.",
    "fullDescription": "Emamectin 5% WDG in 75gm pack is ideal for small to medium field applications.",
    "groupKey": "emamectin-benzoate-series",
    "groupTitle": "Emamectin Benzoate Series",
    "variantLabel": "5% WDG (75gm)",
    "labelImage": "/images/ProductLable/Emamection Benzoaite 5WDG 150gm Label_page-0001.jpg"
  },
  {
    "id": 30,
    "name": "Fentrol (Fipronil) 5% SC",
    "category": "Insecticide",
    "slug": "fentrol-fipronil-5-480",
    "packSize": "480 ml",
    "price": 795,
    "image": "/images/Fentrol.jpeg",
    "description": "Premium fipronil suspension concentrate.",
    "fullDescription": "Fentrol (Fipronil) 5% SC is a premium suspension concentrate for broad-spectrum pest control.",
    "groupKey": "fentrol-5-sc",
    "groupTitle": "Fentrol (Fipronil) 5% SC",
    "variantLabel": "480 ml",
    "labelImage": "/images/ProductLable/Fentrol (Fipronil) 480ml Label_page-0001.jpg"
  },
  {
    "id": 31,
    "name": "Fentrol (Fipronil) 5% SC (1000ml)",
    "category": "Insecticide",
    "slug": "fentrol-fipronil-5-1000",
    "packSize": "1000 ml",
    "price": 1495,
    "image": "/images/Fentrol.jpeg",
    "description": "Large pack premium fipronil.",
    "fullDescription": "Fentrol (Fipronil) 5% SC in 1L pack provides economical option for extensive applications.",
    "groupKey": "fentrol-5-sc",
    "groupTitle": "Fentrol (Fipronil) 5% SC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Fentrol (Fipronil) 480ml Label_page-0001.jpg"
  },
  {
    "id": 32,
    "name": "Freedom 11.6% SC (CTRPR+EMA 100ml)",
    "category": "Insecticide",
    "slug": "freedom-11-6-100",
    "packSize": "100 ml",
    "price": 530,
    "image": "/images/Freedom.jpeg",
    "description": "Combined formulation imported.",
    "fullDescription": "Freedom 11.6% SC imported containing Chlorantraniliprole and Emamectin offers dual-action pest control.",
    "groupKey": "freedom-11-6-sc",
    "groupTitle": "Freedom 11.6% SC (CTPR+EMA)",
    "variantLabel": "100 ml",
    "labelImage": "/images/ProductLable/Freedom (Sudao) 100ml Label_page-0001.jpg"
  },
  {
    "id": 33,
    "name": "Freedom 11.6% SC (CTRPR+EMA 150ml)",
    "category": "Insecticide",
    "slug": "freedom-11-6-150",
    "packSize": "150 ml",
    "price": 720,
    "image": "/images/Freedom.jpeg",
    "description": "Medium pack dual-action formulation.",
    "fullDescription": "Freedom 11.6% SC in 150ml pack provides convenient size for field applications.",
    "groupKey": "freedom-11-6-sc",
    "groupTitle": "Freedom 11.6% SC (CTPR+EMA)",
    "variantLabel": "150 ml",
    "labelImage": "/images/ProductLable/Freedom (Sudao) 100ml Label_page-0001.jpg"
  },
  {
    "id": 34,
    "name": "Instant Super 50% SG",
    "category": "Insecticide",
    "slug": "instant-super-50-sg",
    "packSize": "50 gm",
    "price": 0,
    "image": "/images/instantsuper.jpeg",
    "description": "Soluble granule formulation.",
    "fullDescription": "Instant Super 50% SG is a soluble granule formulation for quick solution preparation and application.",
    "groupKey": "instant-super-50-sg",
    "groupTitle": "Instant Super 50% SG",
    "variantLabel": "50 gm"
  },
  {
    "id": 35,
    "name": "Koral 50% WDG",
    "category": "Insecticide",
    "slug": "koral-50-wdg",
    "packSize": "40 gm",
    "price": 0,
    "image": "/images/pukameng.jpeg",
    "description": "Water-dispersible granule product.",
    "fullDescription": "Koral 50% WDG is a water-dispersible granule formulation for convenient field application.",
    "groupKey": "koral-50-wdg",
    "groupTitle": "Koral 50% WDG",
    "variantLabel": "40 gm"
  },
  {
    "id": 36,
    "name": "Lamdacyhalothrin 2.5% EC (1000ml)",
    "category": "Insecticide",
    "slug": "lamdacyhalothrin-2-5-1000",
    "packSize": "1000 ml",
    "price": 840,
    "image": "/images/lambdacythorine.jpeg",
    "description": "Synthetic pyrethroid concentrate.",
    "fullDescription": "Lamdacyhalothrin 2.5% EC is a synthetic pyrethroid for effective broad-spectrum pest control.",
    "groupKey": "lamdacyhalothrin-2-5-ec",
    "groupTitle": "Lamdacyhalothrin 2.5% EC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Lambda 1000ml Label 2026  ٖ_page-0001.jpg"
  },
  {
    "id": 37,
    "name": "Lamdacyhalothrin 2.5% EC (500ml)",
    "category": "Insecticide",
    "slug": "lamdacyhalothrin-2-5-500",
    "packSize": "500 ml",
    "price": 450,
    "image": "/images/lambdacythorine.jpeg",
    "description": "Medium pack pyrethroid concentrate.",
    "fullDescription": "Lamdacyhalothrin 2.5% EC in 500ml pack provides practical size for field applications.",
    "groupKey": "lamdacyhalothrin-2-5-ec",
    "groupTitle": "Lamdacyhalothrin 2.5% EC",
    "variantLabel": "500 ml",
    "labelImage": "/images/ProductLable/Lambda 1000ml Label 2026  ٖ_page-0001.jpg"
  },
  {
    "id": 38,
    "name": "Lamdacyhalothrin 2.5% EC (250ml)",
    "category": "Insecticide",
    "slug": "lamdacyhalothrin-2-5-250",
    "packSize": "250 ml",
    "price": 280,
    "image": "/images/lambdacythorine.jpeg",
    "description": "Small pack pyrethroid concentrate.",
    "fullDescription": "Lamdacyhalothrin 2.5% EC in 250ml pack is ideal for small field applications.",
    "groupKey": "lamdacyhalothrin-2-5-ec",
    "groupTitle": "Lamdacyhalothrin 2.5% EC",
    "variantLabel": "250 ml",
    "labelImage": "/images/ProductLable/Lambda 1000ml Label 2026  ٖ_page-0001.jpg"
  },
  {
    "id": 39,
    "name": "Lejing 60% WDG",
    "category": "Insecticide",
    "slug": "lejing-60-wdg",
    "packSize": "100 gm",
    "price": 700,
    "image": "/images/lejing.jpeg",
    "description": "Imported water-dispersible granule.",
    "fullDescription": "Lejing 60% WDG imported offers premium water-dispersible granule format for pest control.",
    "groupKey": "lejing-60-wdg",
    "groupTitle": "Lejing 60% WDG",
    "variantLabel": "100 gm",
    "labelImage": "/images/ProductLable/Lijing 100gm Label (HDP 250ml)_page-0001.jpg"
  },
  {
    "id": 40,
    "name": "Leufenuron 5% EC",
    "category": "Insecticide",
    "slug": "leufenuron-5-ec",
    "packSize": "400 ml",
    "price": 500,
    "image": "/images/lufenuron.jpeg",
    "description": "Chitin synthesis inhibitor concentrate.",
    "fullDescription": "Leufenuron 5% EC is a chitin synthesis inhibitor effective against lepidopteran pests.",
    "groupKey": "leufenuron-5-ec",
    "groupTitle": "Lufenuron 5% EC",
    "variantLabel": "400 ml",
    "labelImage": "/images/ProductLable/Lufenuron 400ml Label_page-0001.jpg"
  },
  {
    "id": 41,
    "name": "Manyu 27% FS (Seed Treatment)",
    "category": "Insecticide",
    "slug": "manyu-27-fs-seed-treatment",
    "packSize": "150 ml",
    "price": 650,
    "image": "/images/minyou.jpeg",
    "description": "Imported seed treatment formulation.",
    "fullDescription": "Manyu 27% FS imported is specifically designed for seed treatment to protect against soil and seed-borne pests.",
    "groupKey": "manyu-27-fs",
    "groupTitle": "Manyu 27% FS (Seed Treatment)",
    "variantLabel": "150 ml",
    "labelImage": "/images/ProductLable/Manyu 27FS 150ml label_page-0001.jpg"
  },
  {
    "id": 42,
    "name": "Niko 20% SG",
    "category": "Insecticide",
    "slug": "niko-20-sg",
    "packSize": "100 gm",
    "price": 350,
    "image": "/images/niko.jpeg",
    "description": "Imported soluble granule.",
    "fullDescription": "Niko 20% SG imported is a soluble granule formulation for convenient field application.",
    "groupKey": "niko-20-sg",
    "groupTitle": "Niko 20% SG",
    "variantLabel": "100 gm",
    "labelImage": "/images/ProductLable/Niko (Dinotefuran) 100gm Digital Printed_page-0001.jpg"
  },
  {
    "id": 43,
    "name": "Pyriprixifin 10.8% EC",
    "category": "Insecticide",
    "slug": "pyriprixifin-10-8-ec",
    "packSize": "500 ml",
    "price": 875,
    "image": "/images/pyriprdxyfen.jpeg",
    "description": "Pyrethroid-based concentrate formulation.",
    "fullDescription": "Pyriprixifin 10.8% EC is a pyrethroid-based concentrate for effective pest control.",
    "groupKey": "pyriprixifin-10-8-ec",
    "groupTitle": "Pyriproxyfen 10.8% EC",
    "variantLabel": "500 ml",
    "labelImage": "/images/ProductLable/Pyriproxyfen 500ml Label_page-0001.jpg"
  },
  {
    "id": 44,
    "name": "Sadi 25% ZC (Lambda 12% + Clothiandin 13%)",
    "category": "Insecticide",
    "slug": "sadi-25-zc",
    "packSize": "200 ml",
    "price": 650,
    "image": "/images/SADI.jpeg",
    "description": "Combined pyrethroid and neonicotinoid.",
    "fullDescription": "Sadi 25% ZC imported contains Lambda-cyhalothrin and Clothianidin for broad-spectrum pest control.",
    "groupKey": "sadi-25-zc",
    "groupTitle": "Sadi 25% ZC (Lambda+Clothianidin)",
    "variantLabel": "200 ml",
    "labelImage": "/images/ProductLable/Sadi 25ZC (Lambdacyhalothrin + Clothianidin) 25ZC 200ml Label_page-0001.jpg"
  },
  {
    "id": 45,
    "name": "Sega Pest Clear 3% SC",
    "category": "Insecticide",
    "slug": "sega-pest-clear-3-400",
    "packSize": "400 ml",
    "price": 475,
    "image": "/images/segapest.jpeg",
    "description": "Suspension concentrate formulation.",
    "fullDescription": "Sega Pest Clear 3% SC is a suspension concentrate for effective pest management.",
    "groupKey": "sega-pest-clear-3-sc",
    "groupTitle": "Sega Pest Clear 3% SC",
    "variantLabel": "400 ml",
    "labelImage": "/images/ProductLable/Sega Pest Clear 1000ml Label_page-0001.jpg"
  },
  {
    "id": 46,
    "name": "Sega Pest Clear 3% SC (1000ml)",
    "category": "Insecticide",
    "slug": "sega-pest-clear-3-1000",
    "packSize": "1000 ml",
    "price": 960,
    "image": "/images/segapest.jpeg",
    "description": "Large pack suspension concentrate.",
    "fullDescription": "Sega Pest Clear 3% SC in 1L pack is economical for larger field applications.",
    "groupKey": "sega-pest-clear-3-sc",
    "groupTitle": "Sega Pest Clear 3% SC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Sega Pest Clear 1000ml Label_page-0001.jpg"
  },
  {
    "id": 47,
    "name": "Shiding 21% EC",
    "category": "Insecticide",
    "slug": "shiding-21-ec",
    "packSize": "800 ml",
    "price": 1150,
    "image": "/images/shiding.jpeg",
    "description": "Premium emulsifiable concentrate.",
    "fullDescription": "Shiding 21% EC is a premium emulsifiable concentrate for comprehensive pest control.",
    "groupKey": "shiding-21-ec",
    "groupTitle": "Shiding 21% EC",
    "variantLabel": "800 ml",
    "labelImage": "/images/ProductLable/Shiding 800ml Label 2026 _page-0001.jpg"
  },
  {
    "id": 48,
    "name": "Thiamethaxim 25% WG",
    "category": "Insecticide",
    "slug": "thiamethaxim-25-wg",
    "packSize": "48 gm",
    "price": 180,
    "image": "/images/thiamethoxam.jpeg",
    "description": "Imported neonicotinoid wettable granule.",
    "fullDescription": "Thiamethaxim 25% WG imported is a neonicotinoid for sucking insect control.",
    "groupKey": "thiamethoxam-25-wg",
    "groupTitle": "Thiamethoxam 25% WG",
    "variantLabel": "48 gm"
  },
  {
    "id": 49,
    "name": "Togo 30% SC",
    "category": "Insecticide",
    "slug": "togo-30-sc",
    "packSize": "50 ml",
    "price": 720,
    "image": "/images/togo.jpeg",
    "description": "Imported suspension concentrate.",
    "fullDescription": "Togo 30% SC imported is a suspension concentrate for effective pest management.",
    "groupKey": "togo-30-sc",
    "groupTitle": "Togo 30% SC",
    "variantLabel": "50 ml",
    "labelImage": "/images/ProductLable/Togo 30SC 50ml Label 2026_page-0001.jpg"
  },
  {
    "id": 50,
    "name": "Yupu 45% WDG (EMA 5% + LUE 40%)",
    "category": "Insecticide",
    "slug": "yupu-45-wdg",
    "packSize": "40 gm",
    "price": 475,
    "image": "/images/yupu.jpeg",
    "description": "Combined formulation water-dispersible granule.",
    "fullDescription": "Yupu 45% WDG imported containing Emamectin and Lufenuron is a water-dispersible granule for broad pest control.",
    "groupKey": "yupu-45-wdg",
    "groupTitle": "Yupu 45% WDG (EMA+LUE)",
    "variantLabel": "40 gm"
  },
  {
    "id": 51,
    "name": "Thiostarplus 56% SC (Azoxy+Chlorothalonil)",
    "category": "Fungicide",
    "slug": "thiostarplus-56-sc",
    "packSize": "500 ml",
    "price": 1150,
    "image": "/images/thaistarplus.jpeg",
    "description": "Combined broad-spectrum fungicide.",
    "fullDescription": "Thiostarplus 56% SC imported contains Azoxystrobin and Chlorothalonil for comprehensive fungal disease control.",
    "groupKey": "thiostarplus-56-sc",
    "groupTitle": "Thiostarplus 56% SC",
    "variantLabel": "500 ml"
  },
  {
    "id": 52,
    "name": "Cyclone 72% (Cymoxinal+Mancozeb)",
    "category": "Fungicide",
    "slug": "cyclone-72",
    "packSize": "600 gm",
    "price": 1150,
    "image": "/images/Cyclone72%.jpeg",
    "description": "Combined fungicide powder formulation.",
    "fullDescription": "Cyclone 72% imported containing Cymoxanil and Mancozeb is effective against late blight and other fungal diseases.",
    "groupKey": "cyclone-72",
    "groupTitle": "Cyclone 72% (Cymoxanil+Mancozeb)",
    "variantLabel": "600 gm"
  },
  {
    "id": 53,
    "name": "Copperoxychloride 50% WP",
    "category": "Fungicide",
    "slug": "copperoxychloride-50-wp",
    "packSize": "1000 gm",
    "price": 2100,
    "image": "/images/copper.jpeg",
    "description": "Copper-based fungicide wettable powder.",
    "fullDescription": "Copperoxychloride 50% WP is a copper-based fungicide for bacterial and fungal disease management.",
    "groupKey": "copperoxychloride-50-wp",
    "groupTitle": "Copper Oxychloride 50% WP",
    "variantLabel": "1000 gm"
  },
  {
    "id": 54,
    "name": "Finer 50% SC (Tubaconazole+Azoxy)",
    "category": "Fungicide",
    "slug": "finer-50-sc",
    "packSize": "120 ml",
    "price": 725,
    "image": "/images/finer.jpeg",
    "description": "Combined triazole and strobilurin.",
    "fullDescription": "Finer 50% SC imported containing Tubaconazole and Azoxystrobin provides dual-action fungal disease control.",
    "groupKey": "finer-50-sc",
    "groupTitle": "Finer 50% SC (Tebuconazole+Azoxy)",
    "variantLabel": "120 ml"
  },
  {
    "id": 55,
    "name": "Kanglezine 18.7% WG (Pyraclostrobin+Dimethomorph)",
    "category": "Fungicide",
    "slug": "kanglezine-18-7",
    "packSize": "250 gm",
    "price": 650,
    "image": "/images/kanglixin.jpeg",
    "description": "Combined strobilurin and morpholine.",
    "fullDescription": "Kanglezine 18.7% WG imported contains Pyraclostrobin and Dimethomorph for comprehensive disease management.",
    "groupKey": "kanglezine-18-7-wg",
    "groupTitle": "Kanglezine 18.7% WG",
    "variantLabel": "250 gm"
  },
  {
    "id": 56,
    "name": "Metalaxyl+Mancozeb 72% WP (100gm)",
    "category": "Fungicide",
    "slug": "metalaxyl-mancozeb-72-100",
    "packSize": "100 gm",
    "price": 240,
    "image": "/images/Metalaxyl+mancozab.jpeg",
    "description": "Small pack combination fungicide.",
    "fullDescription": "Metalaxyl+Mancozeb 72% WP imported in small pack is ideal for trial applications.",
    "groupKey": "metalaxyl-mancozeb-72-wp",
    "groupTitle": "Metalaxyl+Mancozeb 72% WP",
    "variantLabel": "100 gm"
  },
  {
    "id": 57,
    "name": "Metalaxyl+Mancozeb 72% WP (250gm)",
    "category": "Fungicide",
    "slug": "metalaxyl-mancozeb-72-250",
    "packSize": "250 gm",
    "price": 550,
    "image": "/images/Metalaxyl+mancozab.jpeg",
    "description": "Medium pack combination fungicide.",
    "fullDescription": "Metalaxyl+Mancozeb 72% WP imported provides economical option for disease management.",
    "groupKey": "metalaxyl-mancozeb-72-wp",
    "groupTitle": "Metalaxyl+Mancozeb 72% WP",
    "variantLabel": "250 gm"
  },
  {
    "id": 58,
    "name": "Metalaxyl+Mancozeb 72% WP (500gm)",
    "category": "Fungicide",
    "slug": "metalaxyl-mancozeb-72-500",
    "packSize": "500 gm",
    "price": 950,
    "image": "/images/Metalaxyl+mancozab.jpeg",
    "description": "Large pack combination fungicide.",
    "fullDescription": "Metalaxyl+Mancozeb 72% WP imported in larger pack is economical for extensive applications.",
    "groupKey": "metalaxyl-mancozeb-72-wp",
    "groupTitle": "Metalaxyl+Mancozeb 72% WP",
    "variantLabel": "500 gm"
  },
  {
    "id": 59,
    "name": "Metalaxyl+Mancozeb 72% WP (1000gm)",
    "category": "Fungicide",
    "slug": "metalaxyl-mancozeb-72-1000",
    "packSize": "1000 gm",
    "price": 1900,
    "image": "/images/Metalaxyl+mancozab.jpeg",
    "description": "Bulk pack combination fungicide.",
    "fullDescription": "Metalaxyl+Mancozeb 72% WP imported in bulk 1kg pack is ideal for large-scale operations.",
    "groupKey": "metalaxyl-mancozeb-72-wp",
    "groupTitle": "Metalaxyl+Mancozeb 72% WP",
    "variantLabel": "1000 gm"
  },
  {
    "id": 60,
    "name": "Oxyrich 40% WP (Copper+Cymoxinal)",
    "category": "Fungicide",
    "slug": "oxyrich-40-wp",
    "packSize": "600 gm",
    "price": 1250,
    "image": "/images/Oxyrich.jpeg",
    "description": "Combined copper and cymoxanil.",
    "fullDescription": "Oxyrich 40% WP imported contains Copper and Cymoxanil for broad-spectrum disease control.",
    "groupKey": "oxyrich-40-wp",
    "groupTitle": "Oxyrich 40% WP (Copper+Cymoxanil)",
    "variantLabel": "600 gm"
  },
  {
    "id": 61,
    "name": "Profile 47% (Copper+Kasuga 250gm)",
    "category": "Fungicide",
    "slug": "profile-47-250",
    "packSize": "250 gm",
    "price": 800,
    "image": "/images/Profile.jpeg",
    "description": "Medium pack copper combination.",
    "fullDescription": "Profile 47% imported containing Copper and Kasuga-Mycin is effective against fungal diseases.",
    "groupKey": "profile-47-wp",
    "groupTitle": "Profile 47% (Copper+Kasuga)",
    "variantLabel": "250 gm"
  },
  {
    "id": 62,
    "name": "Profile 47% (Copper+Kasuga 400gm)",
    "category": "Fungicide",
    "slug": "profile-47-400",
    "packSize": "400 gm",
    "price": 1300,
    "image": "/images/Profile.jpeg",
    "description": "Large pack copper combination.",
    "fullDescription": "Profile 47% imported in larger pack provides economical solution for disease management.",
    "groupKey": "profile-47-wp",
    "groupTitle": "Profile 47% (Copper+Kasuga)",
    "variantLabel": "400 gm"
  },
  {
    "id": 63,
    "name": "Pyrazole 50% (Tubaconazole+Pyraclostrobin)",
    "category": "Fungicide",
    "slug": "pyrazole-50",
    "packSize": "100 gm",
    "price": 500,
    "image": "/images/Pyrazole.jpeg",
    "description": "Premium dual-action fungicide.",
    "fullDescription": "Pyrazole 50% imported combines Tubaconazole and Pyraclostrobin for comprehensive fungal disease control.",
    "groupKey": "pyrazole-50",
    "groupTitle": "Pyrazole 50% (Tebuconazole+Pyraclostrobin)",
    "variantLabel": "100 gm"
  },
  {
    "id": 64,
    "name": "Recado Super 32% (Propiconazole+Azoxy)",
    "category": "Fungicide",
    "slug": "recado-super-32",
    "packSize": "200 ml",
    "price": 790,
    "image": "/images/Recado.jpeg",
    "description": "Combined triazole and strobilurin.",
    "fullDescription": "Recado Super 32% imported contains Propiconazole and Azoxystrobin for effective disease prevention.",
    "groupKey": "recado-super-32",
    "groupTitle": "Recado Super 32% (Propiconazole+Azoxy)",
    "variantLabel": "200 ml"
  },
  {
    "id": 65,
    "name": "Sulphur 80% WG",
    "category": "Fungicide",
    "slug": "sulphur-80-wg-1kg",
    "packSize": "1 kg",
    "price": 675,
    "image": "/images/Sulphur.jpeg",
    "description": "Imported sulphur fungicide granules.",
    "fullDescription": "Sulphur 80% WG imported is a classic fungicide for powdery mildew and other fungal disease control.",
    "groupKey": "sulphur-80-wg",
    "groupTitle": "Sulphur 80% WG",
    "variantLabel": "1 kg"
  },
  {
    "id": 66,
    "name": "Sulphur 80% WG (2kg)",
    "category": "Fungicide",
    "slug": "sulphur-80-wg-2kg",
    "packSize": "2 kg",
    "price": 1250,
    "image": "/images/Sulphur80.jpeg",
    "description": "Medium pack sulphur fungicide.",
    "fullDescription": "Sulphur 80% WG imported in 2kg pack provides economical option for larger applications.",
    "groupKey": "sulphur-80-wg",
    "groupTitle": "Sulphur 80% WG",
    "variantLabel": "2 kg"
  },
  {
    "id": 67,
    "name": "Sulphur 80% WG (10kg)",
    "category": "Fungicide",
    "slug": "sulphur-80-wg-10kg",
    "packSize": "10 kg",
    "price": 6000,
    "image": "/images/Sulphur.jpeg",
    "description": "Large pack sulphur fungicide.",
    "fullDescription": "Sulphur 80% WG imported in 10kg pack is economical for large-scale disease management.",
    "groupKey": "sulphur-80-wg",
    "groupTitle": "Sulphur 80% WG",
    "variantLabel": "10 kg"
  },
  {
    "id": 68,
    "name": "Sulphur 80% WG (25kg)",
    "category": "Fungicide",
    "slug": "sulphur-80-wg-25kg",
    "packSize": "25 kg",
    "price": 14500,
    "image": "/images/Sulphur.jpeg",
    "description": "Bulk pack sulphur fungicide.",
    "fullDescription": "Sulphur 80% WG imported in bulk 25kg pack is ideal for commercial farming operations.",
    "groupKey": "sulphur-80-wg",
    "groupTitle": "Sulphur 80% WG",
    "variantLabel": "25 kg"
  },
  {
    "id": 69,
    "name": "Thiophenatemethyl 70% WP (100gm)",
    "category": "Fungicide",
    "slug": "thiophenatemethyl-70-wp-100",
    "packSize": "100 gm",
    "price": 260,
    "image": "/images/Thiophenate.jpeg",
    "description": "Small pack benzimidazole fungicide.",
    "fullDescription": "Thiophenatemethyl 70% WP imported is a benzimidazole fungicide for various fungal diseases.",
    "groupKey": "thiophenatemethyl-70-wp",
    "groupTitle": "Thiophenate-methyl 70% WP",
    "variantLabel": "100 gm"
  },
  {
    "id": 70,
    "name": "Thiophenatemethyl 70% WP (400gm)",
    "category": "Fungicide",
    "slug": "thiophenatemethyl-70-wp-400",
    "packSize": "400 gm",
    "price": 740,
    "image": "/images/Thiophenate.jpeg",
    "description": "Large pack benzimidazole fungicide.",
    "fullDescription": "Thiophenatemethyl 70% WP imported in larger pack is economical for field applications.",
    "groupKey": "thiophenatemethyl-70-wp",
    "groupTitle": "Thiophenate-methyl 70% WP",
    "variantLabel": "400 gm"
  },
  {
    "id": 71,
    "name": "Trifloxystrobin+Tubaconazole 75%",
    "category": "Fungicide",
    "slug": "trifloxystrobin-tubaconazole-75",
    "packSize": "65 gm",
    "price": 700,
    "image": "/images/Trifloxy.jpeg",
    "description": "Premium combination fungicide.",
    "fullDescription": "Trifloxystrobin+Tubaconazole 75% imported combines strobilurin and triazole for comprehensive disease control.",
    "groupKey": "trifloxystrobin-tubaconazole-75",
    "groupTitle": "Trifloxystrobin+Tebuconazole 75%",
    "variantLabel": "65 gm"
  },
  {
    "id": 72,
    "name": "Trifort 25% WP (Triadimifon)",
    "category": "Fungicide",
    "slug": "trifort-25-wp",
    "packSize": "100 gm",
    "price": 175,
    "image": "/images/Trifloxy.jpeg",
    "description": "Triazine fungicide wettable powder.",
    "fullDescription": "Trifort 25% WP containing Triadimifon is effective against powdery mildew and rust diseases.",
    "groupKey": "trifort-25-wp",
    "groupTitle": "Trifort 25% WP (Triadimefon)",
    "variantLabel": "100 gm"
  },
  {
    "id": 73,
    "name": "Vito 50% WP (Propinep+Metalaxyl)",
    "category": "Fungicide",
    "slug": "vito-50-wp",
    "packSize": "700 gm",
    "price": 2100,
    "image": "/images/Vito.jpeg",
    "description": "Combined dithiocarbamate and acylalanine.",
    "fullDescription": "Vito 50% WP imported containing Propineb and Metalaxyl is effective against late blight and downy mildew.",
    "groupKey": "vito-50-wp",
    "groupTitle": "Vito 50% WP (Propineb+Metalaxyl)",
    "variantLabel": "700 gm"
  },
  {
    "id": 74,
    "name": "Atrazin 38% SC (500ml)",
    "category": "Herbicide",
    "slug": "atrazin-38-sc-500",
    "packSize": "500 ml",
    "price": 590,
    "image": "/images/Atrazine.jpeg",
    "description": "Imported selective herbicide concentrate.",
    "fullDescription": "Atrazin 38% SC imported is a selective triazine herbicide for weed control in corn and cereals.",
    "groupKey": "atrazin-38-sc",
    "groupTitle": "Atrazine 38% SC",
    "variantLabel": "500 ml"
  },
  {
    "id": 75,
    "name": "Atrazin 38% SC (1000ml)",
    "category": "Herbicide",
    "slug": "atrazin-38-sc-1000",
    "packSize": "1000 ml",
    "price": 975,
    "image": "/images/Atrazine.jpeg",
    "description": "Large pack selective herbicide.",
    "fullDescription": "Atrazin 38% SC imported in 1L pack provides economical option for larger field areas.",
    "groupKey": "atrazin-38-sc",
    "groupTitle": "Atrazine 38% SC",
    "variantLabel": "1000 ml"
  },
  {
    "id": 76,
    "name": "Blade 30% SC (Topramezone)",
    "category": "Herbicide",
    "slug": "blade-30-sc",
    "packSize": "35 ml",
    "price": 725,
    "image": "/images/BLADE.jpeg",
    "description": "Imported selective herbicide.",
    "fullDescription": "Blade 30% SC imported containing Topramezone is selective for post-emergence weed control in corn.",
    "groupKey": "blade-30-sc",
    "groupTitle": "Blade 30% SC (Topramezone)",
    "variantLabel": "35 ml"
  },
  {
    "id": 77,
    "name": "Butachlor 60% EC",
    "category": "Herbicide",
    "slug": "butachlor-60-ec",
    "packSize": "800 ml",
    "price": 800,
    "image": "/images/Butachlor.jpeg",
    "description": "Imported pre-emergence herbicide.",
    "fullDescription": "Butachlor 60% EC imported is a selective chloroacetamide herbicide for rice and other crops.",
    "groupKey": "butachlor-60-ec",
    "groupTitle": "Butachlor 60% EC",
    "variantLabel": "800 ml"
  },
  {
    "id": 78,
    "name": "Dormal 75% WG (Halosulfuron)",
    "category": "Herbicide",
    "slug": "dormal-75-wg",
    "packSize": "20 gm",
    "price": 520,
    "image": "/images/jiangbao.jpeg",
    "description": "Imported sulfonylurea herbicide.",
    "fullDescription": "Dormal 75% WG containing Halosulfuron is a selective sulfonylurea herbicide for broad-leaved weed control.",
    "groupKey": "dormal-75-wg",
    "groupTitle": "Dormal 75% WG (Halosulfuron)",
    "variantLabel": "20 gm"
  },
  {
    "id": 79,
    "name": "G-Fast Glyphosate 88.8% WSG (100gm)",
    "category": "Herbicide",
    "slug": "g-fast-glyphosate-88-8-100",
    "packSize": "100 gm",
    "price": 230,
    "image": "/images/G-Fast.jpeg",
    "description": "Small pack non-selective herbicide.",
    "fullDescription": "G-Fast Glyphosate 88.8% WSG imported is a non-selective systemic herbicide for general weed control.",
    "groupKey": "g-fast-glyphosate-88-8",
    "groupTitle": "G-Fast Glyphosate 88.8% WSG",
    "variantLabel": "100 gm"
  },
  {
    "id": 80,
    "name": "G-Fast Glyphosate 88.8% WSG (400gm)",
    "category": "Herbicide",
    "slug": "g-fast-glyphosate-88-8-400",
    "packSize": "400 gm",
    "price": 900,
    "image": "/images/G-Fast.jpeg",
    "description": "Large pack non-selective herbicide.",
    "fullDescription": "G-Fast Glyphosate 88.8% WSG imported in larger pack is economical for extensive weed management.",
    "groupKey": "g-fast-glyphosate-88-8",
    "groupTitle": "G-Fast Glyphosate 88.8% WSG",
    "variantLabel": "400 gm"
  },
  {
    "id": 81,
    "name": "Gazoner 15% EC (250ml)",
    "category": "Herbicide",
    "slug": "gazoner-15-ec-250",
    "packSize": "250 ml",
    "price": 650,
    "image": "/images/Gazoner.jpeg",
    "description": "Selective grass herbicide concentrate.",
    "fullDescription": "Gazoner 15% EC is a selective post-emergence herbicide for grass weed control.",
    "groupKey": "gazoner-15-ec",
    "groupTitle": "Gazoner 15% EC",
    "variantLabel": "250 ml"
  },
  {
    "id": 82,
    "name": "Gazoner 15% EC (500ml)",
    "category": "Herbicide",
    "slug": "gazoner-15-ec-500",
    "packSize": "500 ml",
    "price": 1080,
    "image": "/images/Gazoner.jpeg",
    "description": "Large pack grass herbicide.",
    "fullDescription": "Gazoner 15% EC in 500ml pack provides economical option for grass weed management.",
    "groupKey": "gazoner-15-ec",
    "groupTitle": "Gazoner 15% EC",
    "variantLabel": "500 ml"
  },
  {
    "id": 83,
    "name": "Gengwei 55% SC (1000ml)",
    "category": "Herbicide",
    "slug": "gengwei-55-sc-1000-imported",
    "packSize": "1000 ml",
    "price": 1450,
    "image": "/images/GENGWI.jpeg",
    "description": "Imported herbicide concentrate.",
    "fullDescription": "Gengwei 55% SC imported is an effective herbicide for weed control.",
    "groupKey": "gengwei-55-sc",
    "groupTitle": "Gengwei 55% SC",
    "variantLabel": "1000 ml (Imported)",
    "labelImage": "/images/ProductLable/Gengwei 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 84,
    "name": "Gengwei 55% SC (500ml)",
    "category": "Herbicide",
    "slug": "gengwei-55-sc-500-imported",
    "packSize": "500 ml",
    "price": 800,
    "image": "/images/GENGWI.jpeg",
    "description": "Medium pack herbicide concentrate.",
    "fullDescription": "Gengwei 55% SC imported in 500ml pack is practical for field applications.",
    "groupKey": "gengwei-55-sc",
    "groupTitle": "Gengwei 55% SC",
    "variantLabel": "500 ml",
    "labelImage": "/images/ProductLable/Gengwei 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 85,
    "name": "Gengwei 55% SC (1000ml)",
    "category": "Herbicide",
    "slug": "gengwei-55-sc-1000",
    "packSize": "1000 ml",
    "price": 1250,
    "image": "/images/GENGWI.jpeg",
    "description": "Herbicide concentrate formulation.",
    "fullDescription": "Gengwei 55% SC is an effective herbicide for comprehensive weed control.",
    "groupKey": "gengwei-55-sc",
    "groupTitle": "Gengwei 55% SC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Gengwei 1Ltr Label_page-0001.jpg"
  },
  {
    "id": 86,
    "name": "Glyphosate 48% SL",
    "category": "Herbicide",
    "slug": "glyphosate-48-sl",
    "packSize": "1000 ml",
    "price": 980,
    "image": "/images/Glyphosate.jpeg",
    "description": "Imported non-selective herbicide.",
    "fullDescription": "Glyphosate 48% SL imported is a non-selective systemic herbicide for broad weed management.",
    "groupKey": "glyphosate-48-sl",
    "groupTitle": "Glyphosate 48% SL",
    "variantLabel": "1000 ml"
  },
  {
    "id": 87,
    "name": "Metafin Super 28.5%",
    "category": "Herbicide",
    "slug": "metafin-super-28-5",
    "packSize": "14 gm",
    "price": 125,
    "image": "/images/metaphin.jpeg",
    "description": "Selective herbicide granule.",
    "fullDescription": "Metafin Super 28.5% is a selective herbicide for rice weed management.",
    "groupKey": "metafin-super-28-5",
    "groupTitle": "Metafin Super 28.5%",
    "variantLabel": "14 gm"
  },
  {
    "id": 88,
    "name": "Paraquat 20% SL",
    "category": "Herbicide",
    "slug": "paraquat-20-sl",
    "packSize": "1000 ml",
    "price": 980,
    "image": "/images/paraquat.jpeg",
    "description": "Imported contact herbicide.",
    "fullDescription": "Paraquat 20% SL imported is a non-selective contact herbicide for rapid weed control.",
    "groupKey": "paraquat-20-sl",
    "groupTitle": "Paraquat 20% SL",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Paraquat 1 Ltr Label 2026_page-0001.jpg"
  },
  {
    "id": 89,
    "name": "Peek 40% EC (Bromo+MCPA 400ml)",
    "category": "Herbicide",
    "slug": "peek-40-ec-400",
    "packSize": "400 ml",
    "price": 825,
    "image": "/images/Peek.jpeg",
    "description": "Combined selective herbicide.",
    "fullDescription": "Peek 40% EC containing Bromoxynyl and MCPA is selective for broad-leaved weed control.",
    "groupKey": "peek-40-ec",
    "groupTitle": "Peek 40% EC (Bromoxynil+MCPA)",
    "variantLabel": "400 ml"
  },
  {
    "id": 90,
    "name": "Peek 40% EC (Bromo+MCPA 800ml)",
    "category": "Herbicide",
    "slug": "peek-40-ec-800",
    "packSize": "800 ml",
    "price": 1495,
    "image": "/images/Peek.jpeg",
    "description": "Large pack selective herbicide.",
    "fullDescription": "Peek 40% EC in larger 800ml pack provides economical option for comprehensive weed management.",
    "groupKey": "peek-40-ec",
    "groupTitle": "Peek 40% EC (Bromoxynil+MCPA)",
    "variantLabel": "800 ml"
  },
  {
    "id": 91,
    "name": "Pendi+Acetachlor 42% EC",
    "category": "Herbicide",
    "slug": "pendi-acetachlor-42-ec",
    "packSize": "800 ml",
    "price": 1200,
    "image": "/images/pendimethalinace.jpeg",
    "description": "Combined pre-emergence herbicide.",
    "fullDescription": "Pendi+Acetachlor 42% EC combines Pendimethalin and Acetachlor for broad weed spectrum control.",
    "groupKey": "pendi-acetachlor-42-ec",
    "groupTitle": "Pendi+Acetachlor 42% EC",
    "variantLabel": "800 ml",
    "labelImage": "/images/ProductLable/Pendi + Aceto 800ml Label_page-0001.jpg"
  },
  {
    "id": 92,
    "name": "Pendimethalin 33% EC",
    "category": "Herbicide",
    "slug": "pendimethalin-33-ec",
    "packSize": "1000 ml",
    "price": 1325,
    "image": "/images/pendimethalin.jpeg",
    "description": "Pre-emergence herbicide concentrate.",
    "fullDescription": "Pendimethalin 33% EC is a selective pre-emergence herbicide for various crops.",
    "groupKey": "pendimethalin-33-ec",
    "groupTitle": "Pendimethalin 33% EC",
    "variantLabel": "1000 ml",
    "labelImage": "/images/ProductLable/Pendi + Aceto 800ml Label_page-0001.jpg"
  },
  {
    "id": 93,
    "name": "Walter Super 48% SC",
    "category": "Herbicide",
    "slug": "walter-super-48-sc",
    "packSize": "350 ml",
    "price": 715,
    "image": "/images/waltersuper.jpeg",
    "description": "Premium herbicide suspension.",
    "fullDescription": "Walter Super 48% SC is a suspension concentrate for effective weed control.",
    "groupKey": "walter-super-48-sc",
    "groupTitle": "Walter Super 48% SC",
    "variantLabel": "350 ml"
  },
  {
    "id": 94,
    "name": "Bogata (40+7) Special Imported Recipe",
    "category": "Fertilizer",
    "slug": "bogata-40-7-special",
    "packSize": "8 kg",
    "price": 4750,
    "image": "/images/BOGATA.jpeg",
    "description": "Premium imported special formula.",
    "fullDescription": "Bogata (40+7) Special Imported Recipe is a premium formulation with special composition for enhanced crop nutrition.",
    "groupKey": "bogata-series",
    "groupTitle": "Bogata Humate & Phosphorus Series",
    "variantLabel": "(40+7) Special Recipe (8kg)"
  },
  {
    "id": 95,
    "name": "Bogata (40+7) Solid Potassium Humate",
    "category": "Fertilizer",
    "slug": "bogata-40-7-solid-humate",
    "packSize": "8 kg",
    "price": 1750,
    "image": "/images/BOGATA.jpeg",
    "description": "Potassium humate solid fertilizer.",
    "fullDescription": "Bogata (40+7) with solid potassium humate improves soil structure and nutrient availability.",
    "groupKey": "bogata-series",
    "groupTitle": "Bogata Humate & Phosphorus Series",
    "variantLabel": "(40+7) Solid Humate (8kg)"
  },
  {
    "id": 96,
    "name": "Bogata Plus (P2O5) Phosphorus",
    "category": "Fertilizer",
    "slug": "bogata-plus-p2o5-900",
    "packSize": "20 ltr",
    "price": 900,
    "image": "/images/BogataPlus.jpeg",
    "description": "Phosphorus-rich liquid fertilizer.",
    "fullDescription": "Bogata Plus with P2O5 provides concentrated phosphorus for root development and flowering.",
    "groupKey": "bogata-series",
    "groupTitle": "Bogata Humate & Phosphorus Series",
    "variantLabel": "Plus P2O5 (20L Standard)"
  },
  {
    "id": 97,
    "name": "Bogata Plus (P2O5) Phosphorus Special",
    "category": "Fertilizer",
    "slug": "bogata-plus-p2o5-special",
    "packSize": "20 ltr",
    "price": 11550,
    "image": "/images/BogataPlus.jpeg",
    "description": "Premium phosphorus fertilizer.",
    "fullDescription": "Bogata Plus (P2O5) Special is a premium phosphorus formulation for critical growth stages.",
    "groupKey": "bogata-series",
    "groupTitle": "Bogata Humate & Phosphorus Series",
    "variantLabel": "Plus P2O5 (20L Special)"
  },
  {
    "id": 98,
    "name": "Bokash 25% Organic Matter",
    "category": "Fertilizer",
    "subCategory": "Soil Reclamation",
    "slug": "bokash-25-organic",
    "packSize": "25 kg",
    "price": 2550,
    "image": "/images/BOKASH.jpeg",
    "description": "Organic matter soil conditioner.",
    "fullDescription": "Bokash 25% Organic Matter improves soil health and water retention for sustainable farming.",
    "groupKey": "bokash-25-organic",
    "groupTitle": "Bokash 25% Organic Matter",
    "variantLabel": "25 kg"
  },
  {
    "id": 99,
    "name": "Client 5% Boron (Imported)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "client-5-boron-imported",
    "packSize": "500 ml",
    "price": 875,
    "image": "/images/Client.jpeg",
    "description": "Imported micronutrient boron.",
    "fullDescription": "Client 5% Boron imported provides essential boron for flower and fruit development.",
    "groupKey": "client-5-boron",
    "groupTitle": "Client 5% Boron",
    "variantLabel": "500 ml (Imported)"
  },
  {
    "id": 100,
    "name": "Client 5% Boron",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "client-5-boron",
    "packSize": "500 ml",
    "price": 575,
    "image": "/images/Client.jpeg",
    "description": "Micronutrient boron solution.",
    "fullDescription": "Client 5% Boron is an affordable micronutrient for addressing boron deficiency.",
    "groupKey": "client-5-boron",
    "groupTitle": "Client 5% Boron",
    "variantLabel": "500 ml (Standard)"
  },
  {
    "id": 101,
    "name": "Joba Biostimulant (500ml)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "joba-biostimulant-500",
    "packSize": "500 ml",
    "price": 690,
    "image": "/images/Joba Bio stimulate.jpeg",
    "description": "Biostimulant growth promoter.",
    "fullDescription": "Joba Biostimulant enhances plant vigor and stress tolerance for better yields.",
    "groupKey": "joba-series",
    "groupTitle": "Joba Biostimulant & NPK Series",
    "variantLabel": "Biostimulant (500 ml)"
  },
  {
    "id": 102,
    "name": "Joba Biostimulant (1000ml)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "joba-biostimulant-1000",
    "packSize": "1000 ml",
    "price": 1200,
    "image": "/images/Joba Bio stimulate.jpeg",
    "description": "Medium pack biostimulant.",
    "fullDescription": "Joba Biostimulant in 1L pack provides economical option for larger applications.",
    "groupKey": "joba-series",
    "groupTitle": "Joba Biostimulant & NPK Series",
    "variantLabel": "Biostimulant (1000 ml)"
  },
  {
    "id": 103,
    "name": "Joba Biostimulant (3ltr)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "joba-biostimulant-3ltr",
    "packSize": "3 ltr",
    "price": 3150,
    "image": "/images/Joba Bio stimulate.jpeg",
    "description": "Large pack biostimulant.",
    "fullDescription": "Joba Biostimulant in 3L pack is economical for extensive field coverage.",
    "groupKey": "joba-series",
    "groupTitle": "Joba Biostimulant & NPK Series",
    "variantLabel": "Biostimulant (3 ltr)"
  },
  {
    "id": 104,
    "name": "Joba Plus (NPK 8:8:6)",
    "category": "Fertilizer",
    "slug": "joba-plus-npk-8-8-6",
    "packSize": "1000 ml",
    "price": 675,
    "image": "/images/Jobaplus.jpeg",
    "description": "Balanced NPK liquid fertilizer.",
    "fullDescription": "Joba Plus NPK 8:8:6 provides balanced nutrition for overall plant development.",
    "groupKey": "joba-series",
    "groupTitle": "Joba Biostimulant & NPK Series",
    "variantLabel": "Plus NPK 8:8:6 (1000ml)"
  },
  {
    "id": 105,
    "name": "Kastu-K 30% Potash (1000ml)",
    "category": "Fertilizer",
    "slug": "kastu-k-30-potash-1000",
    "packSize": "1000 ml",
    "price": 980,
    "image": "/images/Kastusup.jpeg",
    "description": "Potash-rich liquid fertilizer.",
    "fullDescription": "Kastu-K 30% Potash provides high potassium for improved plant quality and stress tolerance.",
    "groupKey": "kastu-k-30-potash",
    "groupTitle": "Kastu-K 30% Potash",
    "variantLabel": "1000 ml"
  },
  {
    "id": 106,
    "name": "Kastu-K 30% Potash (3ltr)",
    "category": "Fertilizer",
    "slug": "kastu-k-30-potash-3ltr",
    "packSize": "3 ltr",
    "price": 1600,
    "image": "/images/Kastu30%.jpeg",
    "description": "Medium pack potash fertilizer.",
    "fullDescription": "Kastu-K 30% Potash in 3L pack is economical for larger field areas.",
    "groupKey": "kastu-k-30-potash",
    "groupTitle": "Kastu-K 30% Potash",
    "variantLabel": "3 ltr"
  },
  {
    "id": 107,
    "name": "Kastu-K 30% Potash (10ltr)",
    "category": "Fertilizer",
    "slug": "kastu-k-30-potash-10ltr",
    "packSize": "10 ltr",
    "price": 4100,
    "image": "/images/Kastu-k.jpeg",
    "description": "Large pack potash fertilizer.",
    "fullDescription": "Kastu-K 30% Potash in 10L pack provides economical option for extensive applications.",
    "groupKey": "kastu-k-30-potash",
    "groupTitle": "Kastu-K 30% Potash",
    "variantLabel": "10 ltr"
  },
  {
    "id": 108,
    "name": "Kastu-K 30% Potash (20ltr)",
    "category": "Fertilizer",
    "slug": "kastu-k-30-potash-20ltr",
    "packSize": "20 ltr",
    "price": 8250,
    "image": "/images/Kastu-k.jpeg",
    "description": "Bulk pack potash fertilizer.",
    "fullDescription": "Kastu-K 30% Potash in 20L pack is ideal for commercial farming operations.",
    "groupKey": "kastu-k-30-potash",
    "groupTitle": "Kastu-K 30% Potash",
    "variantLabel": "20 ltr"
  },
  {
    "id": 109,
    "name": "Kastu-K 30% Potash (200ltr)",
    "category": "Fertilizer",
    "slug": "kastu-k-30-potash-200ltr",
    "packSize": "200 ltr",
    "price": 73000,
    "image": "/images/Kastu-k.jpeg",
    "description": "Industrial pack potash fertilizer.",
    "fullDescription": "Kastu-K 30% Potash in 200L drum is ideal for large-scale agricultural operations.",
    "groupKey": "kastu-k-30-potash",
    "groupTitle": "Kastu-K 30% Potash",
    "variantLabel": "200 ltr"
  },
  {
    "id": 110,
    "name": "Lagao 12:61:0 (5kg)",
    "category": "Fertilizer",
    "slug": "lagao-12-61-0-5kg",
    "packSize": "5 kg",
    "price": 3300,
    "image": "/images/Lagao.jpeg",
    "description": "Phosphorus-rich NPK powder.",
    "fullDescription": "Lagao 12:61:0 with high phosphorus content supports root and flower development.",
    "groupKey": "lagao-12-61-0",
    "groupTitle": "Lagao 12:61:0",
    "variantLabel": "5 kg"
  },
  {
    "id": 111,
    "name": "Lagao 12:61:0 (10kg)",
    "category": "Fertilizer",
    "slug": "lagao-12-61-0-10kg",
    "packSize": "10 kg",
    "price": 6600,
    "image": "/images/Lagao.jpeg",
    "description": "Large pack phosphorus NPK.",
    "fullDescription": "Lagao 12:61:0 in 10kg pack provides economical option for field applications.",
    "groupKey": "lagao-12-61-0",
    "groupTitle": "Lagao 12:61:0",
    "variantLabel": "10 kg"
  },
  {
    "id": 112,
    "name": "Lali (NPK) 15:17:17",
    "category": "Fertilizer",
    "slug": "lali-npk-15-17-17",
    "packSize": "100 gm",
    "price": 130,
    "image": "/images/Lali.jpeg",
    "description": "Balanced NPK powder fertilizer.",
    "fullDescription": "Lali NPK 15:17:17 provides balanced nutrition for all-round crop development.",
    "groupKey": "lali-npk-15-17-17",
    "groupTitle": "Lali (NPK) 15:17:17",
    "variantLabel": "100 gm"
  },
  {
    "id": 113,
    "name": "Meedan 13.5% Potassium Humate (4ltr)",
    "category": "Fertilizer",
    "subCategory": "Soil Reclamation",
    "slug": "meedan-13-5-potassium-humate-4ltr",
    "packSize": "4 ltr",
    "price": 825,
    "image": "/images/MedanPlus.jpeg",
    "description": "Humic acid soil conditioner.",
    "fullDescription": "Meedan 13.5% Potassium Humate improves soil structure and nutrient availability.",
    "groupKey": "meedan-series",
    "groupTitle": "Meedan Potassium Humate & Nitrogen Series",
    "variantLabel": "13.5% Humate (4 ltr)"
  },
  {
    "id": 114,
    "name": "Meedan 13.5% Potassium Humate (10ltr)",
    "category": "Fertilizer",
    "subCategory": "Soil Reclamation",
    "slug": "meedan-13-5-potassium-humate-10ltr",
    "packSize": "10 ltr",
    "price": 1600,
    "image": "/images/MedanPlus.jpeg",
    "description": "Medium pack humic acid.",
    "fullDescription": "Meedan 13.5% Potassium Humate in 10L pack is economical for larger applications.",
    "groupKey": "meedan-series",
    "groupTitle": "Meedan Potassium Humate & Nitrogen Series",
    "variantLabel": "13.5% Humate (10 ltr)"
  },
  {
    "id": 115,
    "name": "Meedan 13.5% Potassium Humate (20ltr)",
    "category": "Fertilizer",
    "subCategory": "Soil Reclamation",
    "slug": "meedan-13-5-potassium-humate-20ltr",
    "packSize": "20 ltr",
    "price": 2950,
    "image": "/images/MedanPlus.jpeg",
    "description": "Large pack humic acid.",
    "fullDescription": "Meedan 13.5% Potassium Humate in 20L pack provides economical soil conditioning.",
    "groupKey": "meedan-series",
    "groupTitle": "Meedan Potassium Humate & Nitrogen Series",
    "variantLabel": "13.5% Humate (20 ltr)"
  },
  {
    "id": 116,
    "name": "Meedan 13.5% Potassium Humate (200ltr)",
    "category": "Fertilizer",
    "subCategory": "Soil Reclamation",
    "slug": "meedan-13-5-potassium-humate-200ltr",
    "packSize": "200 ltr",
    "price": 28500,
    "image": "/images/MedanPlus.jpeg",
    "description": "Industrial pack humic acid.",
    "fullDescription": "Meedan 13.5% Potassium Humate in 200L drum is ideal for large-scale operations.",
    "groupKey": "meedan-series",
    "groupTitle": "Meedan Potassium Humate & Nitrogen Series",
    "variantLabel": "13.5% Humate (200 ltr)"
  },
  {
    "id": 117,
    "name": "Meedan Plus 20% (N 20% - 200ltr)",
    "category": "Fertilizer",
    "slug": "meedan-plus-20-n-200ltr",
    "packSize": "200 ltr",
    "price": 65550,
    "image": "/images/MedanPlus.jpeg",
    "description": "Industrial nitrogen fertilizer.",
    "fullDescription": "Meedan Plus 20% with 20% nitrogen in 200L drum is ideal for large commercial operations.",
    "groupKey": "meedan-series",
    "groupTitle": "Meedan Potassium Humate & Nitrogen Series",
    "variantLabel": "Plus 20% N (200 ltr)"
  },
  {
    "id": 118,
    "name": "Meedan Plus 20% (N 20% - 20ltr)",
    "category": "Fertilizer",
    "slug": "meedan-plus-20-n-20ltr",
    "packSize": "20 ltr",
    "price": 6800,
    "image": "/images/MedanPlus.jpeg",
    "description": "Bulk nitrogen fertilizer.",
    "fullDescription": "Meedan Plus 20% with high nitrogen content supports vegetative growth.",
    "groupKey": "meedan-series",
    "groupTitle": "Meedan Potassium Humate & Nitrogen Series",
    "variantLabel": "Plus 20% N (20 ltr)"
  },
  {
    "id": 119,
    "name": "SOP (0:0:51) 18S Egypt (10kg)",
    "category": "Fertilizer",
    "slug": "sop-0-0-51-18s-egypt-10kg",
    "packSize": "10 kg",
    "price": 4350,
    "image": "/images/SOP.jpeg",
    "description": "Egyptian potassium sulfate.",
    "fullDescription": "SOP (0:0:51) 18S from Egypt provides pure potassium without chloride.",
    "groupKey": "sop-0-0-51",
    "groupTitle": "SOP (0:0:51) Egypt",
    "variantLabel": "18S (10kg)"
  },
  {
    "id": 120,
    "name": "SOP (0:0:51) 17S Egypt (25kg)",
    "category": "Fertilizer",
    "slug": "sop-0-0-51-17s-egypt-25kg",
    "packSize": "25 kg",
    "price": 10300,
    "image": "/images/SOP.jpeg",
    "description": "Large pack Egyptian potassium.",
    "fullDescription": "SOP (0:0:51) 17S from Egypt in 25kg bag is economical for field applications.",
    "groupKey": "sop-0-0-51",
    "groupTitle": "SOP (0:0:51) Egypt",
    "variantLabel": "17S (25kg)"
  },
  {
    "id": 121,
    "name": "Urea Phosphate",
    "category": "Fertilizer",
    "slug": "urea-phosphate",
    "packSize": "10 kg",
    "price": 5000,
    "image": "/images/UREA-PHOS.jpeg",
    "description": "Nitrogen-phosphorus combination.",
    "fullDescription": "Urea Phosphate combines nitrogen and phosphorus for balanced plant nutrition.",
    "groupKey": "urea-phosphate",
    "groupTitle": "Urea Phosphate",
    "variantLabel": "10 kg"
  },
  {
    "id": 122,
    "name": "Zelura-ZN Chelated Zinc 5% Powder",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "zelura-zn-chelated-zinc-5-powder",
    "packSize": "500 gm",
    "price": 1125,
    "image": "/images/ZeluraPlus.jpeg",
    "description": "Chelated zinc micronutrient powder.",
    "fullDescription": "Zelura-ZN Chelated Zinc 5% Powder addresses zinc deficiency in crops.",
    "groupKey": "zelura-series",
    "groupTitle": "Zelura Chelated Zinc Micronutrient Series",
    "variantLabel": "5% Powder (500gm)"
  },
  {
    "id": 123,
    "name": "Zelura-ZN Chelated Zinc 5% Solid",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "zelura-zn-chelated-zinc-5-solid",
    "packSize": "2 kg",
    "price": 1225,
    "image": "/images/ZeluraPlus.jpeg",
    "description": "Chelated zinc solid formulation.",
    "fullDescription": "Zelura-ZN Chelated Zinc 5% Solid provides readily available zinc for crop nutrition.",
    "groupKey": "zelura-series",
    "groupTitle": "Zelura Chelated Zinc Micronutrient Series",
    "variantLabel": "5% Solid (2kg)"
  },
  {
    "id": 124,
    "name": "Gagi 7:2:1",
    "category": "Fertilizer",
    "slug": "gagi-7-2-1",
    "packSize": "5 kg",
    "price": 950,
    "image": "/images/GAGI-75-sp.jpeg",
    "description": "Nitrogen-rich NPK fertilizer.",
    "fullDescription": "Gagi 7:2:1 with high nitrogen supports vegetative growth.",
    "groupKey": "gagi-7-2-1",
    "groupTitle": "Gagi 7:2:1 NPK Fertilizer",
    "variantLabel": "5 kg"
  },
  {
    "id": 125,
    "name": "Zelura Plus (Zinc 10% - 200ltr)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "zelura-plus-zinc-10-200ltr",
    "packSize": "200 ltr",
    "price": 39000,
    "image": "/images/zeluraplus40.jpeg",
    "description": "Industrial zinc micronutrient.",
    "fullDescription": "Zelura Plus Zinc 10% in 200L drum provides concentrated zinc for large operations.",
    "groupKey": "zelura-series",
    "groupTitle": "Zelura Chelated Zinc Micronutrient Series",
    "variantLabel": "Plus 10% Liquid (200 ltr)"
  },
  {
    "id": 126,
    "name": "Zelura Plus (Zinc 10% - 3ltr)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "zelura-plus-zinc-10-3ltr",
    "packSize": "3 ltr",
    "price": 900,
    "image": "/images/zeluraplus40.jpeg",
    "description": "Medium pack zinc fertilizer.",
    "fullDescription": "Zelura Plus Zinc 10% in 3L pack is practical for field applications.",
    "groupKey": "zelura-series",
    "groupTitle": "Zelura Chelated Zinc Micronutrient Series",
    "variantLabel": "Plus 10% Liquid (3 ltr)"
  },
  {
    "id": 127,
    "name": "Zelura Plus (Zinc 10% - 20ltr)",
    "category": "Fertilizer",
    "subCategory": "Special Nutrients",
    "slug": "zelura-plus-zinc-10-20ltr",
    "packSize": "20 ltr",
    "price": 4300,
    "image": "/images/zeluraplus40.jpeg",
    "description": "Large pack zinc fertilizer.",
    "fullDescription": "Zelura Plus Zinc 10% in 20L pack is economical for larger field coverage.",
    "groupKey": "zelura-series",
    "groupTitle": "Zelura Chelated Zinc Micronutrient Series",
    "variantLabel": "Plus 10% Liquid (20 ltr)"
  },
  {
    "id": 128,
    "name": "Alcone 0.4G (CTPR)",
    "category": "Fertilizer",
    "subCategory": "Granules",
    "slug": "alcone-0-4g-ctpr-4kg",
    "packSize": "4 kg",
    "price": 0,
    "image": "/images/FullCoontrol.jpeg",
    "description": "Granular soil insecticide.",
    "fullDescription": "Alcone 0.4G is a granular formulation for soil application providing protection against soil pests.",
    "groupKey": "alcone-0-4g-ctpr",
    "groupTitle": "Alcone 0.4G (CTPR)",
    "variantLabel": "4 kg"
  },
  {
    "id": 129,
    "name": "Alcone 0.4G (CTPR) (8kg)",
    "category": "Fertilizer",
    "subCategory": "Granules",
    "slug": "alcone-0-4g-ctpr-8kg",
    "packSize": "8 kg",
    "price": 1050,
    "image": "/images/FullCoontrol.jpeg",
    "description": "Large pack granular insecticide.",
    "fullDescription": "Alcone 0.4G in 8kg pack provides effective soil pest control for larger areas.",
    "groupKey": "alcone-0-4g-ctpr",
    "groupTitle": "Alcone 0.4G (CTPR)",
    "variantLabel": "8 kg"
  },
  {
    "id": 130,
    "name": "Spectral 0.69G (CTPR+Thiamethaxim)",
    "category": "Fertilizer",
    "subCategory": "Granules",
    "slug": "spectral-0-69g-ctpr-thiamethaxim",
    "packSize": "7 kg",
    "price": 0,
    "image": "/images/Success.jpeg",
    "description": "Combined granular insecticide.",
    "fullDescription": "Spectral 0.69G is a granular formulation combining Chlorantraniliprole and Thiamethaxim for effective soil and contact pest protection.",
    "groupKey": "spectral-0-69g-ctpr",
    "groupTitle": "Spectral 0.69G (CTPR+Thiamethoxam)",
    "variantLabel": "7 kg"
  },
  {
    "id": 131,
    "name": "Monomehypo 5G",
    "category": "Fertilizer",
    "subCategory": "Granules",
    "slug": "monomehypo-5g",
    "packSize": "7 kg",
    "price": 0,
    "image": "/images/pukameng.jpeg",
    "description": "Granular pest control product.",
    "fullDescription": "Monomehypo 5G is a granular formulation for effective pest management and soil application.",
    "groupKey": "monomehypo-5g",
    "groupTitle": "Monomehypo 5G",
    "variantLabel": "7 kg"
  },
  {
    "id": 132,
    "name": "Rada",
    "category": "Fertilizer",
    "subCategory": "Household",
    "slug": "rada",
    "packSize": "200 ml",
    "price": 550,
    "image": "/images/rada.jpeg",
    "description": "Household pest control product.",
    "fullDescription": "Rada is an everyday household product for practical pest protection around the home.",
    "groupKey": "rada",
    "groupTitle": "Rada Household Insecticide",
    "variantLabel": "200 ml"
  },
  {
    "id": 133,
    "name": "Lambda 25% WP Sachet",
    "category": "Fertilizer",
    "subCategory": "Household",
    "slug": "lambda-25-wp-sachet",
    "packSize": "62.5 gm",
    "price": 195,
    "image": "/images/lambdacythorine.jpeg",
    "description": "Household insecticide sachet.",
    "fullDescription": "Lambda 25% WP in convenient sachet form is ideal for household pest management.",
    "groupKey": "lambda-25-wp-sachet",
    "groupTitle": "Lambda 25% WP Sachet",
    "variantLabel": "62.5 gm",
    "labelImage": "/images/ProductLable/Lambda 1000ml Label 2026  ٖ_page-0001.jpg"
  }
];
